// Services
import { CiiFleetRatingsSchema, getFleetRatings, GetFleetRatingsParams } from '@services/index';
// Schemas
import { QueryFunctionContext } from '@tanstack/react-query';

/**
 * Fetches fleet ratings for a specific client and year.
 *
 * @param {number} startDate - The start date for fetching fleet ratings.
 * @param {number} endDate - The end date for fetching fleet ratings.
 * @param {number} clientTimezoneOffset - The client's timezone offset in minutes.
 * @param {boolean} isDataExport - Flag indicating whether the data is for export.
 * @returns {Promise<CiiFleetRatings>} - A promise that resolves to the fetched fleet ratings.
 */
export const fleetRatingsController = async ({ queryKey }: QueryFunctionContext) => {
  const [_, params] = queryKey;
  const { startDate, endDate, isDataExport, clientTimezoneOffset } = params as GetFleetRatingsParams;

  const { data } = await getFleetRatings({
    clientTimezoneOffset,
    startDate,
    endDate,
    isDataExport,
  });
  const fleetRatingsData = CiiFleetRatingsSchema.parse(data);

  return fleetRatingsData;
};
